import Immutable from 'immutable';

export const INIT_STATE = Immutable.fromJS({
  list: [],
});



/** WEBPACK FOOTER **
 ** ./src/pages/ucBindEmail/constants/index.js
 **/